import React from "react";
import { Alert, Box, Button, Text } from "@showitinc/showit-wc";
import ButtonBar from "../base/ButtonBar";
import uiPrefix from "../../utils/UiPrefixUtils";

class FolderChooser extends React.Component {
  static defaultProps = {
    folders: [],
    width: 300,
    height: 400,
    title: "Move Assets To",
    actionLabel: "Move",
    cancelLabel: "Cancel",
  };

  constructor(props) {
    super(props);
    let selected = null;
    if (props.selected) {
      selected = props.selected;
    }

    this.state = {
      selected,
    };
  }

  _select = (folder) => {
    this.setState({ selected: folder });
  };

  _submit = () => {
    if (this.props.onChoose) {
      this.props.onChoose(this.state.selected);
    }
  };

  render() {
    const { folders, width, height } = this.props;

    return (
      <div
        className="si-dialog"
        style={{ display: "flex", flexDirection: "column", width, height }}
      >
        <div className="si-dialog-header" style={{ flex: "0 0 auto" }}>
          {this.props.title}
        </div>
        <div className="si-table selectable" style={{ flex: "1 1 auto", margin: "8px 8px 0px" }}>
          <div
            className={`si-table-row${this.state.selected == null ? " selected" : ""}`}
            onClick={this._select.bind(this, null)}
          >
            <Text>Uploads</Text>
          </div>
          {folders.map(function (folder, idx) {
            const className = `si-table-row${this.state.selected === folder ? " selected" : ""}`;

            return (
              <div
                key={idx}
                className={className}
                data-testid="folder-chooser-option"
                onClick={this._select.bind(this, folder)}
              >
                <Text>{folder.name}</Text>
              </div>
            );
          }, this)}
        </div>
        <ButtonBar align="space-between" style={{ padding: 10, flex: "0 0 auto" }}>
          <Button
            data-e2e={uiPrefix("modal-cancel-btn")}
            className={uiPrefix("modal-cancel-btn")}
            onClick={this.props.onCancel}
            variant="minimal"
          >
            {this.props.cancelLabel}
          </Button>
          <Button
            data-e2e={uiPrefix("modal-save-btn")}
            className={uiPrefix("modal-save-btn")}
            onClick={this._submit}
            variant="feature"
          >
            {this.props.actionLabel}
          </Button>
        </ButtonBar>
      </div>
    );
  }
}

export default FolderChooser;
